import { render } from "./ClawView.vue?vue&type=template&id=3a7198be"
import script from "./ClawView.vue?vue&type=script&lang=js"
export * from "./ClawView.vue?vue&type=script&lang=js"

import "./ClawView.vue?vue&type=style&index=0&id=3a7198be&lang=css"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_zendesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__